import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import globals from '../globals'
import ServiceDetails from '../modules/ServiceDetails'
import Documents from '../modules/Documents'
import SubNavigation from '../modules/SubNavigation'
import DataSource from '../DataSource'
import CancelMobileService from '../modules/CancelMobileService'
import { NETWORK_TELSTRA, SERVICE_WIRELESS } from '../constants'
import ChangePlanMobile from '../modules/ChangePlanMobile'
import UsageSummary from '../modules/UsageSummary'
import AjaxLoader from '../components/AjaxLoader'
import ServiceHeading from '../modules/ServiceHeading'
import MigrateWireless from '../modules/MigrateWireless'
import CustomLink from '../components/CustomLink'
import { isBrowser } from 'react-device-detect'
import { TweenMax } from 'gsap'

class WirelessService extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
		    isLoaded: false,
            hasErrors: false,
            serviceId: parseInt(this.props.match.params.id),
            serviceDetails: {}
        }

        this.type = SERVICE_WIRELESS
    }

    componentDidMount () {
        DataSource.getData(`/api/getService/${this.type}/${this.state.serviceId}`, result => {
            this.setState({
                serviceDetails: { ...result, ...result.serviceDetails },
                isLoaded: true
            })
            globals.animatePageIn(this.container)
        }, () => {
            this.setState({ isLoaded: true, hasErrors: true })
        })
    }

    getSubNav () {
        let subNav = [
            { title: 'Usage summary', url: '' },
            { title: 'Service details', url: '/service-details' }
        ]

        if (!this.state.serviceDetails.inContract && this.isTelstra()) {
            subNav.push({ title: 'Change my plan', url: '/change-plan' })
        }

        if (!this.isTelstra()) {
            subNav.push({ title: 'Migrate my service', url: '/migrate' })
        }

        subNav = [...subNav,
            { title: 'My documents', url: '/my-documents' },
            { title: 'Cancel my service', url: '/cancel-service' }
        ]

        return subNav
    }

    isTelstra () {
        return this.state.serviceDetails && this.state.serviceDetails.networkProvider === NETWORK_TELSTRA
    }

    render () {
        const RenderMyUsage = () => {
            return (
                <UsageSummary
                    type={this.type}
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderServiceDetails = () => {
		    return (
    <ServiceDetails
                    title='My home wireless broadband service details'
                    details={this.state.serviceDetails.data}
                />
            )
        }

        const RenderDocuments = () => {
            return (
                <Documents
                    title='My documents'
                    type={this.type}
                    serviceId={this.state.serviceId}
                />
            )
        }

        const RenderChangePlanMobile = () => {
            return (
                <ChangePlanMobile
                    title='Change my plan'
                    type={this.type}
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderMigrateWireless = () => {
            return (
                <MigrateWireless
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const RenderCancelMobileService = () => {
            return (
                <CancelMobileService
                    title='Cancel my service'
                    type={this.type}
                    serviceId={this.state.serviceId}
                    serviceDetails={this.state.serviceDetails}
                />
            )
        }

        const scrollToNav = () => {
            if (document.getElementById('sub-navigation')) {
                if (isBrowser) {
                    TweenMax.to(window, 0.5, { scrollTo: { y: document.getElementById('sub-navigation'), offsetY: 60 } })
                } else {
                    if (document.getElementById('sub-navigation-mobile')) {
                        TweenMax.to(window, 0.5, { scrollTo: { y: document.getElementById('sub-navigation-mobile'), offsetY: 40 } })
                    } else {
                        TweenMax.to(window, 0.5, { scrollTo: { y: document.getElementById('sub-navigation'), offsetY: 75 } })
                    }
                }
            }
        }

        const handleClickLink = event => {
            event.preventDefault()
            scrollToNav()
            this.props.history.push(`/my-services/hwbb/${this.state.serviceId}/migrate`)
        }

        const MigrateBanner = () => {
		    return (
                <div className='col-12 col-lg-7 d-flex align-items-center justify-content-end flex-column flex-lg-row mt-3 mt-lg-0'>
        <div className='mr-lg-3 mb-3 mb-lg-0 text-center text-lg-left'>
                        <p className='font-xsmall lh m-0'>
                <span className='bold'>IMPORTANT:</span> Your Home Wireless Broadband service on the Optus network will be cancelled on 31 July 2022. To continue using your Exetel Home Wireless Broadband service you will need to migrate your service to one of our plans on the Telstra network before this date. Please choose a migration plan asap.
            </p>
                    </div>
        <CustomLink onClick={handleClickLink} className='text-nowrap btn btn-custom'>Migrate service now</CustomLink>
    </div>
            )
        }

        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        if (this.state.hasErrors) {
            return <Redirect push to='/' />
        }

        return (
            <div ref={el => this.container = el} style={{ opacity: 0 }}>
                <ServiceHeading
                    type={this.type}
                    icon='/images/icon-hwbb.svg'
                    smallText={this.state.serviceDetails.serviceNo}
                    medText={this.state.serviceDetails.description}
                    colClassLg='col-lg-5'
                >
                    {!this.isTelstra() ? <MigrateBanner /> : ''}
                </ServiceHeading>

                <SubNavigation
                    title='Manage my service'
                    items={this.getSubNav()}
                    url={this.props.match.url}
                    className='gtm-service-manage-tab-click'
                />

                <Switch>
                    <Route exact path={this.props.match.url} render={RenderMyUsage} />
                    <Route exact path={`${this.props.match.url}/service-details`} render={RenderServiceDetails} />
                    <Route exact path={`${this.props.match.url}/my-documents`} render={RenderDocuments} />
                    {!this.state.serviceDetails.inContract && this.isTelstra()
                        ? <Route exact path={`${this.props.match.url}/change-plan`} render={RenderChangePlanMobile} />
                        : ''}
                    {!this.isTelstra() ? <Route exact path={`${this.props.match.url}/migrate`} render={RenderMigrateWireless} /> : ''}
                    <Route exact path={`${this.props.match.url}/cancel-service`} render={RenderCancelMobileService} />
                </Switch>
            </div>
        )
    }
}

export default withRouter(WirelessService)



// WEBPACK FOOTER //
// ./resources/js/services/WirelessService.js